import React from 'react';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../../../store/useGradesTableStore';
import useGames from '../../../hooks/queries/exerciseResults/useGames';
import isAwaitingData from '../../../hooks/queries/isAwaitingData';
import { IGame } from '../../../types';
import GradeCellSkeleton from './GradeCellSkeleton';
import { compareFn } from './GamesGradeCell';

export const STATE_CAPITALS_GAME = {
  game_type: 'Geography Game',
  id: 1,
  max_score: 50,
} as IGame;

interface StateCapitalsGradeCellProps {
  studentId: number;
}

const StateCapitalsGradeCell = ({ studentId }: StateCapitalsGradeCellProps) => {
  const classroom = useGradesTableStore(state => state.classroom);
  const lesson = useGradesTableStore(state => state.lesson);
  const programId = useGradesTableStore(state => state.programId);

  const gamesQuery = useGames();
  const { data: exerciseResults } = gamesQuery;

  if (isAwaitingData(gamesQuery)) return <GradeCellSkeleton />;

  const exerciseResult = exerciseResults.find(er => compareFn(er, STATE_CAPITALS_GAME, studentId));

  if (!exerciseResult) return <>-</>;

  const url = Routes.games_shared_question_answers_path(studentId, {
    activity_type: 'state_capitals',
    classroom_id: classroom.id,
    lesson_id: lesson.id,
    program_id: programId,
    game_id: STATE_CAPITALS_GAME.id,
  });

  return (
    <a
      className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full"
      href={url}
      id={`state-capitals-game-${STATE_CAPITALS_GAME.id}-student-${studentId}-score`}
    >
      {exerciseResult?.score ? exerciseResult.score.replace('.0', '') : '-'}
    </a>
  );
};

export default StateCapitalsGradeCell;
